import { $, Selector } from '@zeus/index'
import { typedGql } from '@zeus/typedDocumentNode'

/** Identifiants émis UNE fois (#271) : à remettre ou imprimer tout de suite. */
const credentialsSelector = Selector('UsernameCredentials')({
  userId: true,
  username: true,
  password: true,
})

export const GQL_CREATE_USERNAME_LEARNER = typedGql('mutation')({
  createUsernameLearner: [{ input: $('input', 'CreateUsernameLearnerInput!') }, credentialsSelector],
})

export const GQL_IMPORT_USERNAME_LEARNERS = typedGql('mutation')({
  importUsernameLearners: [
    { learners: $('learners', '[ImportUsernameLearnerInput!]!') },
    { created: credentialsSelector, errors: { line: true, username: true, reason: true } },
  ],
})

export const GQL_RESET_USERNAME_LEARNER_PASSWORD = typedGql('mutation')({
  resetUsernameLearnerPassword: [{ userId: $('userId', 'String!') }, credentialsSelector],
})
